<template>
  <b-card>
    <validation-observer ref="interestRules">
      <b-form>
        <b-row class="mt-2">
          <b-col md="6">
            <InputField
              id="no-of-accruing-interest"
              v-model.number="interestFormData.config.numberOfAccruingInterestDaysInAYear"
              :label="$t('No of Accruing Interest Days in a Year')"
              :placeholder="$t('No of Accruing Interest Days in a Year')"
              type="number"
              :error-name="$t('No of Accruing Interest Days in a Year')"
              rules="required|integer|positive"
              for="no-of-accruing-interest"
              :readonly="isReadonly"
            />
          </b-col>

          <b-col md="6">
            <InputField
              id="no-of-yielding-interest"
              v-model.number="interestFormData.config.numberOfYieldingInterestDaysInAYear"
              :label="$t('No of Yielding Interest Days in a Year')"
              :placeholder="$t('No of Yielding Interest Days in a Year')"
              type="number"
              :error-name="$t('No of Accruing Interest Days in a Year')"
              rules="required|integer|positive"
              for="no-of-yielding-interest"
              :readonly="isReadonly"
            />
          </b-col>

          <b-col md="6">
            <b-form-checkbox
              id="accrue-debit"
              v-model="interestFormData.config.accrueDebitInterestWhereAccountNotFunded"
              checked="false"
              name="check-button"
              switch
              inline
              :disabled="isReadonly"
            >
              {{ $t('Accrue Debit Interest where Account is not Funded') }}
            </b-form-checkbox>
          </b-col>
        </b-row>

        <div class="text-center mt-4">
          <Button
            v-if="getUserPermission('MODIFY_SYSTEM_SETUP')"
            :label="buttonLabel"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="saveInterestInformation()"
          />
        </div>
      </b-form>
    </validation-observer>
    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BForm, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver } from 'vee-validate'
import { mapActions } from 'vuex'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { required, positive } from '@validations'
import { permissionMixin } from '@core/mixins/permission'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../../../forms/InputField.vue'
import Button from '../../../../components/button/Button.vue'
import { operationPermissions } from '../../../../../helpers/permissions'

export default {
  components: {
    Button,
    FullScreenSpinner,
    BRow,
    BCol,
    BCard,
    InputField,
    BForm,
    BFormCheckbox,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  mixins: [sweetAlert, permissionMixin],
  data() {
    return {
      required,
      positive,
      isDisabled: false,
      isReadonly: true,
      isEditable: true,
      isLoading: false,
      showSpinner: false,
      buttonLabel: this.$t('Edit'),
      interestFormData: {
        config: {
          numberOfAccruingInterestDaysInAYear: null,
          numberOfYieldingInterestDaysInAYear: null,
          accrueDebitInterestWhereAccountNotFunded: false,
        },
      },
    }
  },
  mounted() {
    this.fetchInterestInformation()
  },
  methods: {
    ...mapActions({
      getInterestInformation: 'operations/getInterestInformationList',
      updateInterestInformation: 'operations/updateInterestInformationAction',
    }),
    saveInterestInformation() {
      if (this.buttonLabel === this.$t('Save Changes')) {
        this.$refs.interestRules.validate().then(success => {
          if (success) {
            this.confirm(this.handleSubmit, { text: this.$t('Are you sure you want to Update this Interest Information?') })
          }
        })
      } else {
        this.isReadonly = false
        this.isEditable = true
        this.buttonLabel = this.$t('Save Changes')
      }
    },
    async handleSubmit() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const response = await this.updateInterestInformation(this.interestFormData)

        const { status } = await response
        if (status === 200) {
          this.fetchInterestInformation()
          this.alertSuccess({ text: this.$t('Your request to Update Interest Information was successful') })
          this.isReadonly = true
          this.isEditable = true
          this.isDisabled = false
          this.isLoading = false
          this.buttonLabel = 'Edit'
        }
      } catch (error) {
        const requestText = this.$t('Your request to Update Interest Information failed. Reason:')
        this.alertError({ text: `${requestText} ${error}` })
      } finally {
        this.isEditable = true
        this.isDisabled = false
        this.isLoading = false
      }
    },
    async fetchInterestInformation() {
      try {
        this.showSpinner = true
        const response = await this.getInterestInformation({
          permission: operationPermissions.VIEW_SYSTEM_SETUP,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.interestFormData.config = { ...data.data }
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
  },
}
</script>
<style scoped>
.custom-checkbox:last-child{
    margin-left: 20px !important;

}
</style>
